import { create } from "zustand";
import moment from "moment";
import { DAY_FORMAT } from "constants/common";
import { AiccFeedbackPostAction, AiccFeedbackType } from "types/model/aiccCustomer";
import { FEEDBACK_PAGE_LIMIT, MIN_DATE } from "./constants";

export interface UserFeedbackAdvancedSearch {
  types: AiccFeedbackType[];
  downvoteTurns: number[];
  postActions: AiccFeedbackPostAction[];
  fluencyLevels: number[];
}

interface UserFeedbackState {
  startDate?: string;
  endDate?: string;
  languageIds: number[];
  customerEmail?: string;
  advancedSearch: UserFeedbackAdvancedSearch;
  page: number;
  limit: number;
  setDateRange: (startDate: string, endDate: string) => void;
  setLanguageIds: (languageIds: number[]) => void;
  setCustomerEmail: (customerEmail?: string) => void;
  setAdvancedSearch: (advancedSearch: UserFeedbackAdvancedSearch) => void;
  setPagination: (page: number, limit: number) => void;
}

export const EMPTY_ADVANCED_SEARCH: UserFeedbackAdvancedSearch = {
  types: [],
  downvoteTurns: [],
  postActions: [],
  fluencyLevels: [],
};

let defaultDateRange: { startDate: string; endDate: string } | undefined;

const getDefaultDateRange = () => {
  if (!defaultDateRange) {
    const oneMonthAgo = moment().subtract(1, "month").format(DAY_FORMAT);

    defaultDateRange = {
      startDate: oneMonthAgo < MIN_DATE ? MIN_DATE : oneMonthAgo,
      endDate: moment().format(DAY_FORMAT),
    };
  }
  return defaultDateRange;
};

export const selectStartDate = (state: UserFeedbackState) => state.startDate ?? getDefaultDateRange().startDate;
export const selectEndDate = (state: UserFeedbackState) => state.endDate ?? getDefaultDateRange().endDate;

export const useUserFeedbackStore = create<UserFeedbackState>((set) => ({
  languageIds: [],
  advancedSearch: EMPTY_ADVANCED_SEARCH,
  page: 1,
  limit: FEEDBACK_PAGE_LIMIT,
  setDateRange: (startDate, endDate) => set({ startDate, endDate, page: 1 }),
  setLanguageIds: (languageIds) => set({ languageIds, page: 1 }),
  setCustomerEmail: (customerEmail) => set({ customerEmail, page: 1 }),
  setAdvancedSearch: (advancedSearch) => set({ advancedSearch, page: 1 }),
  setPagination: (page, limit) => set({ page, limit }),
}));
